import './LaceBottom.css'

function LaceBottom(){
    return(
        <div className="LaceBottom"></div>
    )
}
export default LaceBottom;